<div class="dtf-video">
  <video autoplay width="800" style="top: 0; left: 0;width: 100%; height: 100%; object-fit: cover;" controls>
    <source src="{{this.videoRedirect}}" type="video/mp4">
    Your browser does not support HTML video.
  </video>
  
</div>
